// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { ApplicationGatewayWafDynamicManifestsDefault } from "../operationsInterfaces/index.js";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers.js";
import * as Parameters from "../models/parameters.js";
import type { NetworkManagementClient } from "../networkManagementClient.js";
import type {
  ApplicationGatewayWafDynamicManifestsDefaultGetOptionalParams,
  ApplicationGatewayWafDynamicManifestsDefaultGetResponse,
} from "../models/index.js";

/** Class containing ApplicationGatewayWafDynamicManifestsDefault operations. */
export class ApplicationGatewayWafDynamicManifestsDefaultImpl implements ApplicationGatewayWafDynamicManifestsDefault {
  private readonly client: NetworkManagementClient;

  /**
   * Initialize a new instance of the class ApplicationGatewayWafDynamicManifestsDefault class.
   * @param client Reference to the service client
   */
  constructor(client: NetworkManagementClient) {
    this.client = client;
  }

  /**
   * Gets the regional application gateway waf manifest.
   * @param location The region where the nrp are located at.
   * @param options The options parameters.
   */
  get(
    location: string,
    options?: ApplicationGatewayWafDynamicManifestsDefaultGetOptionalParams,
  ): Promise<ApplicationGatewayWafDynamicManifestsDefaultGetResponse> {
    return this.client.sendOperationRequest({ location, options }, getOperationSpec);
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const getOperationSpec: coreClient.OperationSpec = {
  path: "/subscriptions/{subscriptionId}/providers/Microsoft.Network/locations/{location}/applicationGatewayWafDynamicManifests/dafault",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.ApplicationGatewayWafDynamicManifestResult,
    },
    default: {
      bodyMapper: Mappers.CloudError,
    },
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.$host, Parameters.subscriptionId, Parameters.location],
  headerParameters: [Parameters.accept],
  serializer,
};
